import image from "../../../assets/AdobeStock_615455766.png";
import audio from "../../../assets/audio/turnUpTheRadio.mp3";


export const podcasts = [
    {
        name: "podcast",
        title: ' Rozmowa o bólu i jak przeprowadzić odpowiedni wywiad?',
        image: image,
        subtitle: 'Co Cię boli, jak Cię boli i jak długo Cię boli? Dopytaj, zdiagnozuj i dopiero zaleć.',
        audioUrl: audio,
    },
    {
        name: "podcast 1",
        title: ' Rozmowa podcast numer 2',
        image: image,
        subtitle: 'Co Cię boli, jak Cię boli i jak długo Cię boli? Dopytaj, zdiagnozuj i dopiero zaleć.',
        audioUrl: audio,
    },
    {
        name: "podcast 2",
        title: ' Rozmowa podcast numer 3',
        image: image,
        subtitle: 'Co Cię boli, jak Cię boli i jak długo Cię boli? Dopytaj, zdiagnozuj i dopiero zaleć.',
        audioUrl: audio,
    },

];